(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/part-draw.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/part-draw.js');

'use strict';

svs.numbergames.game.views.PartDraw = Marionette.View.extend({
  className: 'numbergames-footer-section',
  ui: {
    partDrawRadio: '.js-part-draw-radio',
    partDrawInfo: '.js-part-draw-info'
  },
  triggers: {
    'change @ui.partDrawRadio': 'changePartDraw',
    'click @ui.partDrawInfo': 'clickedPartDrawInfo'
  },
  template(data) {
    return svs.numbergames.game.templates.part_draw(data);
  },
  templateContext() {
    const viewOptions = svs.numbergames.game.view_options[this.model.get('productId')];
    return {
      showPartDrawInfo: Boolean(viewOptions.partDrawDialog)
    };
  },
  onChangePartDraw(view, event) {
    this.model.set({
      rowPriceMulti: parseInt(event.target.value, 10)
    });
  },
  onClickedPartDrawInfo() {
    var _viewOptions$partDraw;
    const viewOptions = svs.numbergames.game.view_options[this.model.get('productId')];
    viewOptions === null || viewOptions === void 0 || (_viewOptions$partDraw = viewOptions.partDrawDialog) === null || _viewOptions$partDraw === void 0 || _viewOptions$partDraw.call(viewOptions, this.getUI('partDrawInfo'));
  }
});

 })(window);